import { MultipleRowDefaultPropertiesPanel } from "./MultipleRowDefaultPropertiesPanel";
import { RowDefaultPropertiesPanel } from "./RowDefaultPropertiesPanel";

import {
    setSeatSpacing,
    setRowSeatSize,
    setRowSpacing,
    setSvgIcon,
    setSvgFill,
    setSvgScale,
    setRectTableSeats,
    setRectTableDimensions,
    setRoundTableRadius,
    setRoundTableSeats
} from "../../../redux/designerPropertiesSlice";
import { IconDefaultPropertiesPanel } from "./IconDefaultPropertiesPanel";
import { RectTableDefaultPropertiesPanel } from "./RectTableDefaultPropertiesPanel";
import { RoundTableDefaultPropertiesPanel } from "./RoundTableDefaultPropertiesPanel";

export const DEFAULT_PROPERTIES_DEFINITION = {
    row: {
        title: "Fila",
        component: RowDefaultPropertiesPanel,
        props: (state, dispatch) => ({
            rowSeatSpacing: state.rowSeatSpacing,
            rowSeatSpacingHandler: (value) => dispatch(setSeatSpacing(value)),

            rowSeatSize: state.rowSeatSize,
            rowSeatSizeHandler: (value) => dispatch(setRowSeatSize(value)),
        }),
    },

    multipleRows: {
        title: "Filas Multiples",
        component: MultipleRowDefaultPropertiesPanel,
        props: (state, dispatch) => ({
            rowSeatSpacing: state.rowSeatSpacing,
            rowSeatSpacingHandler: (value) => dispatch(setSeatSpacing(value)),

            rowSeatSize: state.rowSeatSize,
            rowSeatSizeHandler: (value) => dispatch(setRowSeatSize(value)),

            rowSpacing: state.rowSpacing,
            rowSpacingHandler: (value) => dispatch(setRowSpacing(value)),
        }),
    },

    svg: {
        title: 'Iconos',
        component: IconDefaultPropertiesPanel,
        props: (state, dispatch) => ({
            svgIcon: state.svgIcon,
            svgIconHandler: (value) => dispatch(setSvgIcon(value)),

            svgFill: state.svgFill,
            svgFillHandler: (value) => dispatch(setSvgFill(value)),

            svgScale: state.svgScale,
            svgScaleHandler: (value) => dispatch(setSvgScale(value)),
        })
    },

    rectTable: {
        title: 'Mesas',
        component: RectTableDefaultPropertiesPanel,
        props: (state, dispatch) => ({
            rectTableSeats: state.rectTableSeats,
            rectTableSeatsHandler: (key, value) => dispatch(setRectTableSeats({ key, value })),

            rectTableDimensions: state.rectTableDimensions,
            rectTableDimensionsHandler: (key, value) => dispatch(setRectTableDimensions({ key, value })),
        })
    },

    roundTable: {
        title: 'Mesas',
        component: RoundTableDefaultPropertiesPanel,
        props: (state, dispatch) => ({
            roundTableSeats: state.roundTableSeats,
            roundTableSeatsHandler: (value) => dispatch(setRoundTableSeats(value)),

            roundTableRadius: state.roundTableRadius,
            roundTableRadiusHandler: (value) => dispatch(setRoundTableRadius(value)),
        })
    }
};